import React from 'react'
import styled from 'styled-components'
import Item from './header-menu-main-desktop-item.js'
import {useHeaderContext} from './header.js' 
import media from './theme-media.js'

const UnstyledMenuMainDesktop = ({
  className
}) => {
  const header = useHeaderContext()
  const menu = header.menu

  const props = {
    className 
  }

  const items = menu.items.map(item => {
    const props = {
      item,
      key: item.key
    }
    
    return <Item {...props}/>
  })

  return (
    <div {...props}>
      <div>{items}</div>
    </div>
  )
}

const MenuMainDesktop = styled(UnstyledMenuMainDesktop)`
  display: flex;
  align-items: center;
  height: 100%;
  flex-shrink: 0;
  ${media.belowLaptop`
    display: none;
  `}
`

export default MenuMainDesktop